import { DependencyList, useEffect, useState } from 'react';

export const useGetElementInfo = (
  selector: string,
  deps: DependencyList = [],
) => {
  const [elementInfo, setElementInfo] = useState<DOMRect>({} as DOMRect);

  useEffect(() => {
    return setElementInfo(
      document.querySelector(selector)?.getBoundingClientRect?.() ||
        ({} as DOMRect),
    );
  }, [selector, ...deps]);

  return elementInfo;
};
